<template>
  <span
      :class="badgeClasses"
      class="af-badge afu-inline-flex afu-items-center afu-justify-center afu-transition afu-duration-200"
  >
    <slot />
  </span>
</template>

<script>
export default {
    name: 'Badge',

    props: {
        variant: {
            type: String,
            default: 'default',
            validator: (value) => [
                'default',
                'primary',
                'secondary',
                'success',
                'warning',
                'danger',
                'info',
                'light',
                'dark',
                'neutral'
            ].includes(value)
        },
        size: {
            type: String,
            default: 'sm',
            validator: (value) => ['xs', 'sm', 'md', 'lg'].includes(value)
        },
        rounded: {
            type: Boolean,
            default: false
        },
        outline: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        badgeClasses() {
            return [
                this.sizeClasses,
                this.variantClasses,
                this.roundedClasses
            ].join(' ');
        },

        sizeClasses() {
            const sizes = {
                xs: 'afu-px-2 afu-py-0 afu-text-xs',
                sm: 'afu-px-2 afu-py-0 afu-text-sm',
                md: 'afu-px-3 afu-py-0 afu-text-md',
                lg: 'afu-px-4 afu-py-1 afu-text-lg'
            };
            return sizes[this.size];
        },

        variantClasses() {
            return this.solidVariantClasses;
        },

        solidVariantClasses() {
            const variants = {
                default: 'afu-bg-gray-200 afu-text-gray-800',
                primary: 'afu-bg-primary afu-text-white',
                secondary: 'afu-bg-secondary afu-text-white',
                success: 'afu-bg-success afu-text-white',
                warning: 'afu-bg-warning afu-text-white',
                danger: 'afu-bg-danger afu-text-white',
                info: 'afu-bg-info afu-text-white',
                light: 'afu-bg-neutral-light afu-text-neutral-dark',
                dark: 'afu-bg-black afu-text-white',
                neutral: 'afu-bg-neutral afu-text-white'
            };
            return variants[this.variant];
        },
        roundedClasses() {
            return this.rounded ? 'afu-rounded-full' : 'afu-rounded-lg';
        }
    }
};
</script>
